/* Chat - PE (2026-10-10): tap-to-load Gorgias chat.
 * The Gorgias app embed used to print three deferred loaders on every page (chat bundle loader, Convert, mailto-replace:
 * ~30 requests, ~600 KB, ~430 ms main thread). The embed is OFF; this file injects ONLY the chat bundle loader
 * when a [data-paex-chat] trigger is tapped, then opens the widget once window.GorgiasChat is ready. Triggers: the
 * tool-bar block (sections/tool-bar.liquid, paex_chat) and the shipping page help link (paex-shipping.js also calls
 * GorgiasChat.open when it is already present).
 * 2026-10-12: locale-aware — /fr pages load the French Gorgias application, everything else the English one, keyed off
 * <html lang> (request.locale.iso_code). A trigger may force a key via data-paex-chat-key. */
(function () {
  if (window.paexChatFacade) return;
  window.paexChatFacade = true;
  var CHAT_KEYS = {
    en: '01GYCBVCD8VVAAAPW9BF2H9N1B', // Gorgias applicationId 3529 (English)
    fr: '01GYCCDVZDD3R5HJ59BWS1ZEN2' // Gorgias applicationId 17243 (French)
  };
  var loading = false;
  function setBusy(state) {
    document.querySelectorAll('[data-paex-chat]').forEach(function (el) {
      el.setAttribute('aria-busy', state ? 'true' : 'false');
      el.classList.toggle('is-loading', !!state);
    });
  }
  // Gorgias's bundle loader first installs a stub GorgiasChat whose init() promise never settles once the real
  // bundle replaces it, so: call init() once per object we see, call open() on every attempt, stop when isOpen().
  // The stub is a Proxy that THROWS on any property read except init/resolve, so even `typeof chat.open` must be
  // guarded — an unguarded read kills the poll chain while the real bundle is still downloading.
  function readyChat() {
    var chat = window.GorgiasChat;
    if (!chat) return null;
    try { return typeof chat.open === 'function' ? chat : null; } catch (e) { return null; }
  }
  var inited = [];
  function openWhenReady(deadline) {
    var chat = readyChat();
    if (chat) {
      try {
        if (typeof chat.init === 'function' && inited.indexOf(chat) === -1) {
          inited.push(chat);
          var r = chat.init();
          if (r && typeof r.then === 'function') r.then(function () { try { chat.open(); } catch (e) {} }, function () {});
        }
        chat.open();
      } catch (e) {}
      if (typeof chat.isOpen === 'function' && chat.isOpen()) { setBusy(false); return; }
    }
    if (Date.now() > deadline) { setBusy(false); return; }
    setTimeout(function () { openWhenReady(deadline); }, 400);
  }
  function hideGorgiasLauncher() {
    // The tool-bar icon is the only chat button: hide Gorgias's own floating launcher bubble (iframe#chat-button
    // inside #gorgias-chat-container). The chat window is a separate iframe and is not affected.
    if (document.getElementById('paex-chat-style')) return;
    var st = document.createElement('style');
    st.id = 'paex-chat-style';
    st.textContent = '#gorgias-chat-container iframe#chat-button{display:none!important;}';
    document.head.appendChild(st);
  }
  function load(trigger) {
    var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var key = trigger.getAttribute('data-paex-chat-key') || CHAT_KEYS[lang] || CHAT_KEYS.en;
    hideGorgiasLauncher();
    if (!loading && !document.querySelector('script[data-gorgias-loader-chat]')) {
      loading = true;
      var s = document.createElement('script');
      s.defer = true;
      s.setAttribute('data-gorgias-loader-chat', '');
      s.src = 'https://config.gorgias.chat/bundle-loader/' + key;
      s.onerror = function () {
        loading = false;
        setBusy(false);
        if (s.parentNode) s.parentNode.removeChild(s); // leave no dead tag behind, so the next tap can retry
      };
      document.head.appendChild(s);
    }
    setBusy(true);
    openWhenReady(Date.now() + 15000);
  }
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-paex-chat]');
    if (!trigger) return;
    event.preventDefault();
    if (readyChat()) { openWhenReady(Date.now() + 5000); return; }
    load(trigger);
  });
})();
